module.exports = __webpack_public_path__ + "static/media/a11.b2f1f018.jpg";